import { gql } from "../__generated__";

export const GetPlaceTypes = gql(`
  query GetPlaceTypes($take: Int, $where: OrtTypWhereInput) {
    items: ortTyps(take: $take, where: $where) {
      id
      name
    }
  }
`);
